import Dialog from '@/components/Dialog';
import { FormattedMessage } from 'react-intl';

type GenericImageUploadErrorDialogProps = {
  open: boolean;
  attemptedUploadInvolvesMultipleFiles: boolean;
  onClose: () => void;
};

const GenericImageUploadErrorDialog = ({
  open,
  attemptedUploadInvolvesMultipleFiles,
  onClose,
}: GenericImageUploadErrorDialogProps) => (
  <Dialog open={open} onClose={onClose} dangerous>
    <Dialog.Title>
      <FormattedMessage
        id={`portfolio.challenge.files.add.generic_error_dialogs.image_upload.title.${attemptedUploadInvolvesMultipleFiles ? 'plural' : 'singular'}`}
      />
    </Dialog.Title>
    <Dialog.Content>
      <Dialog.ContentText>
        <FormattedMessage
          id={`portfolio.challenge.files.add.generic_error_dialogs.image_upload.text.${attemptedUploadInvolvesMultipleFiles ? 'plural' : 'singular'}`}
        />
      </Dialog.ContentText>
    </Dialog.Content>
    <Dialog.Actions>
      <Dialog.Actions.DeleteButton onClick={onClose}>
        <FormattedMessage id="dialogs.actions.ok" />
      </Dialog.Actions.DeleteButton>
    </Dialog.Actions>
  </Dialog>
);

export default GenericImageUploadErrorDialog;
